<template>
  <span
    class="group flex items-center h-8 rounded-full pl-4 text-sm bg-primary-50 dark:bg-darkblue-600 text-primary flex-none"
  >
    <span class="mr-2 group-hover:text-primary-800 whitespace-pre-wrap">{{ label }} : {{ value }}</span>
    <base-button-icon
      mode="primary-phantom"
      class="label-button "
      name="cross"
      iconSize="xs"
      size="xs"
      @click="removeTag"
    />
  </span>
</template>

<script>
import { TIPOS_FILTER_MULTIPLE } from '@/config/tipos-filter-multiple'

export default {
  name: 'base-filter-tag-item',
  props: {
    tag: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      multipleFilters: TIPOS_FILTER_MULTIPLE,
      // types: [],
    }
  },
  mounted: async function () {
    // this.types = await this.$store.getters['app/invoicesTypes']
  },
  methods: {
    removeTag: function () {
      this.$emit('removeTag', this.tag)
    },
  },
  computed: {
    label: function () {
      return this.tag[1]
    },
    value: function () {
      // Mixin
      var objJson = null
      if ((['idCliente', 'empresa', 'Empresa', 'distribuidor', 'idDistribuidor', 'distribuidor.idDistribuidor', 'metadatos'].includes(this.tag[0]) || /metadatos\d+/.test(this.tag[0])) && typeof this.tag[2] === 'string' && typeof (objJson = JSON.parse(this.tag[2])) === 'object') {
        this.$set(this.tag, 2, objJson)
      }
      return this.getValueTagFormated(this.tag)
    },
    roles: function () {
      return this.$store.getters['config/ROLES']
    },
    tiposAuth: function () {
      return this.$store.getters['config/TIPOS_AUTH']
    },
    tiposEstados: function () {
      return this.$store.getters['config/TIPOS_ESTADO']
    },
    tiposEstadosRecibidas: function () {
      return this.$store.getters['config/TIPOS_ESTADO_RECEPCION']
    },
    tiposOrigenFactura: function () {
      return this.$store.getters['config/TIPOS_ORIGEN_FACTURA']
    },
    tiposCert: function () {
      return this.$store.getters['config/TIPOS_CERT']
    },
    tiposInvoiceClass: function () {
      return this.$store.getters['config/TIPOS_INVOICE_CLASS']
    },
    pgeTypes: function () {
      return this.$store.getters['config/TIPOS_PGE']
    },
    pgeTypesRecepcion: function () {
      return this.$store.getters['config/TIPOS_PGE_RECEPCION']
    },
    tiposGrupo: function () {
      return this.$store.getters['config/TIPOS_GRUPO']
    },
    operators: function () {
      return this.$store.getters['config/OPERADORES']
    },
    tiposDistribuidor: function () {
      return this.$store.getters['config/TIPOS_DISTRIBUIDOR']
    },
    tiposProvisionamiento: function () {
      return this.$store.getters['config/TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO']
    },
    tiposServicio: function () {
      return this.$store.getters['config/TIPOS_SERVICIO']
    },
    tiposPersona: function () {
      return this.$store.getters['config/TIPOS_PERSONA']
    },
    tiposRolAgenda: function () {
      return this.$store.getters['config/TIPOS_ROL_AGENDA']
    },
    tiposResidencia: function () {
      return this.$store.getters['config/TIPOS_RESIDENCIA']
    },
    tiposRolAdministrativeCenter: function () {
      return this.$store.getters['config/TIPOS_ROL_ADMINISTRATIVE_CENTER']
    },
    tiposRolAdministrativeCenterfb2b: function () {
      return this.$store.getters['config/TIPOS_ROL_ADMINISTRATIVE_CENTER_FB2B']
    },
    tiposUnidadesMedida: function () {
      return this.$store.getters['config/TIPOS_UNIDADES_MEDIDA']
    },
    tiposCodigoImpuesto: function () {
      return this.$store.getters['config/TIPOS_CODIGO_IMPUESTO']
    },
    tiposCategoriaImpuesto: function () {
      return this.$store.getters['config/TIPOS_CATEGORIA_IMPUESTOS']
    },
    tiposFiscalidadEspecial: function () {
      return this.$store.getters['config/TIPOS_FISCALIDAD_ESPECIAL']
    },
    tiposWebhookNotification: function () {
      return this.$store.getters['config/TIPOS_WEBHOOK_NOTIFICATION']
    },
    tiposIdioma: function () {
      return this.$store.getters['config/TIPOS_IDIOMA']
    },
    tiposPais: function () {
      return this.$store.getters['config/PAISES']
    },
    formasDePago: function () {
      return this.$store.getters['config/FORMAS_DE_PAGO']
    },
    tiposCuenta: function () {
      return this.$store.getters['config/TIPOS_CUENTA']
    },
    tiposFacturas: function () {
      return this.$store.getters['config/TIPOS_FACTURA']
    },
    tiposEstadoVerifactu: function () {
      return this.$store.getters['config/TIPOS_ESTADO_VERIFACTU']
    },
    tiposOperacion: function () {
      return this.$store.getters['config/TIPOS_OPERACION']
    },
    tiposImportacion () {
      return this.$store.getters['config/TIPOS_IMPORTACION']
    },
    tiposImportacionEstado () {
      return this.$store.getters['config/TIPOS_IMPORTACION_ESTADO']
    },
    tiposPaquetesContratacion () {
      return this.$store.getters['config/TIPOS_PAQUETES_CONTRATACION']
    },
    tiposFasesConfiguracion () {
      return this.$store.getters['config/TIPOS_FASES_CONFIGURACION']
    }
  }
}
</script>

<style lang="scss" scoped></style>
